import { render, staticRenderFns } from "./ApprovalFilesFilters.vue?vue&type=template&id=55fb6004&"
import script from "./ApprovalFilesFilters.vue?vue&type=script&lang=js&"
export * from "./ApprovalFilesFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55fb6004')) {
      api.createRecord('55fb6004', component.options)
    } else {
      api.reload('55fb6004', component.options)
    }
    module.hot.accept("./ApprovalFilesFilters.vue?vue&type=template&id=55fb6004&", function () {
      api.rerender('55fb6004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/ApprovalFilesFilters.vue"
export default component.exports